import React, {FC} from 'react';
import SelectInput from "../../../components/SelectInput";
import {SelectChangeEvent} from "@mui/material";
import {LabelValue} from "../../../types/common/LabelValue";

const sortByOptions = [
  { value: 'COMPANY_NAME', label: 'Company Name' },
  { value: 'CREATION_DATE', label: 'Creation Date' },
  { value: 'ACCOUNT_TYPE', label: 'Account Type' },
  { value: 'COMPANY_EMAIL', label: 'Company Email' },
  { value: 'USERNAME', label: 'Owner Username' },
  { value: 'ACTIVATED', label: 'Account Status' }
] as const satisfies LabelValue[];

// Define SortByValue as a union of the 'value' types from sortByOptions
export type SortByValue = (typeof sortByOptions)[number]['value'];

interface ISortByProps {
  sortByValue: SortByValue | undefined;
  sortDirValue: 'asc' | 'desc' | undefined;
  onSortByChange: (event: SelectChangeEvent) => void;
  onSortDirChange: (sortDir: 'asc' | 'desc') => void;
}

/**
 * The SortBy SortDir combo component for Admin Account Report
 *
 *
 * @param sortByValue - Current selected sort by value
 * @param sortDirValue - Current selected sort direction value
 * @param onSortByChange - event triggered on sort by change
 * @param onSortDirChange - event triggered on sort direction change
 *
 * @return FC<ISortByProps>
 */
const SortBy: FC<ISortByProps> = ({ sortByValue, sortDirValue, onSortByChange, onSortDirChange }) => {

  const handleSortDirChange = (newDir: 'asc' | 'desc') => {
    onSortDirChange(newDir);
  };

  return <SelectInput
    label='Sort By'
    selectData={sortByOptions as unknown as LabelValue[]}
    value={sortByValue}
    hasAction={true}
    onChange={onSortByChange}
    onNextClick={() => handleSortDirChange('asc')}
    onPrevClick={() => handleSortDirChange('desc')}
    activeState={sortDirValue === 'asc'}
    handleToggle={() => handleSortDirChange(sortDirValue === 'asc' ? 'desc' : 'asc')}
  />
};

export default SortBy;